import { render, staticRenderFns } from "./ActivityTrackerSettingsView.vue?vue&type=template&id=b32bfd76&scoped=true&"
import script from "./ActivityTrackerSettingsView.vue?vue&type=script&lang=ts&"
export * from "./ActivityTrackerSettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32bfd76",
  null
  
)

export default component.exports